export default {
  handleError(error) {
    if (error.response.status === 401) {
      // dump the cookies
      console.log(error.response);
      window.localStorage.clear();
      window.location.reload();
    } else {
      console.log(error);
    }
  },
};
